import React, { ReactElement, FunctionComponent, memo } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Touchable from '@sport1/react-elements/Touchable'
import Grid from '@sport1/react-elements/Grid'
import { NavigationListItemBasicProps, BasicListItem } from '../'

export type NavigationListItemFavoriteProps = NavigationListItemBasicProps & {
    /** shows if the item was marked as a favorite or not */
    isActive?: boolean
    /**
     * callback function triggered when headline of NavigationListItemFavorite is pressed
     *
     * @TJS-type function
     */
    onPressHeadline?: () => void
    /**
     * callback function triggered when favorite is pressed
     *
     * @TJS-type function
     */
    onPressFavorite: () => void
}

const Favorite: FunctionComponent<NavigationListItemFavoriteProps> = ({
    isActive,
    onPressHeadline,
    testID,
    onPressFavorite,
    ...rest
}): ReactElement => (
    <Touchable onPress={onPressHeadline}>
        <BasicListItem {...rest} marginRight={0}>
            <Touchable onPress={onPressFavorite} testID={testID}>
                <Grid paddingX={5} minWidth={44} noExpand>
                    <FontelloIcon
                        textAlign="right"
                        name={isActive ? 'favorite-active' : 'favorite'}
                        fontSize={15}
                        color={isActive ? 'ORANGE' : 'keshi-3'}
                    />
                </Grid>
            </Touchable>
        </BasicListItem>
    </Touchable>
)

export default memo(Favorite)
